import React from 'react';
import { NavLink } from 'react-router-dom';

import ImageLazy from '@common/react/components/UI/ImageLazy/ImageLazy';

import Links from '@app/components/UI/components/Links';

import '@app/scss/footer.scss';

const NewFooter: React.FC = () => {
	return (
		<div className="footer">
			<footer className="footer9_component">
				<button
					type="button"
					className="scroll-top-btn"
					onClick={() => {
						window.scroll({ behavior: 'smooth', top: 0 });
					}}
				>
					Back to Top
				</button>
				<div className="padding-global-footer">
					<div className="container-large">
						<div className="w-layout-grid footer9_top-wrapper">
							<div className="footer-content">
								<div>
									<h5>
										Contact Us
									</h5>
									<span>
										1649 North Military Trail
										<br />
										West Palm Beach, FL 33409
										<br />
										<br />
										<a href="tel:+15615125313">(561) 512-5313</a>
										<br />
										<a href="mailto:sales@executivetags.com">sales@executivetags.com</a>
									</span>
								</div>
							</div>
							<div className="footer9_link-list">
								<h5>Links</h5>
								<div className="flex-row">
									<div>
										<NavLink to="/services" aria-current="page" className="footer9_link w--current">Services</NavLink>
										<NavLink to="/about-us" className="footer9_link">About</NavLink>
										<NavLink to="/request-demo" className="footer9_link">Contact us</NavLink>
									</div>
									<div>
										<a
											href="https://portal.dealersuite.com/eStore/faces/pages/customer/index_3PA.jsp?store=exectagtitle"
											target="_blank"
											className="footer9_link"
										>
											Integration | CDK
										</a>
										<NavLink to="/terms-of-use" className="footer9_link">Terms of Service</NavLink>
										<NavLink to="/privacy-policy" className="footer9_link">Privacy Policy</NavLink>
									</div>
									<div>
										<NavLink to="/contact-us?demo=true" className="button demo-button">Request a Demo</NavLink>
										<a href="https://dealers.executivetags.com/" target="_blank" className="button default-button">Login</a>
									</div>
								</div>
							</div>
							<div className="footer9_link-list">
								<h5>Connect with Us</h5>
								<div>
									<Links />
								</div>
							</div>
							<div className="footer9_link-list footer9_logo-link_container">
								<a href="#" className="footer9_logo-link w-nav-br/and">
									<ImageLazy src="/images/footer-logo.png" alt="logo" className="logo-smaller"/>
								</a>
							</div>
						</div>
						<div className="footer9_bottom-wrapper">
							<div className="footer9_credit-text current-year current-year">
								<span className="current-year">{new Date().getFullYear()}</span> © Executive
								Tag &amp; Title Svcs In
								Copyright All Rights Reserved
							</div>
						</div>
					</div>
				</div>
			</footer>
		</div>
	);
};

export default NewFooter;
